// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Def } from "tern";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const eeAppsmithAutocompleteDefs = (generatedTypeDef: Def) => ({});
